import { useEffect } from "react";
import { meGQL, Query, updateUserGQL } from "@onmo/graphql/graphql";
import { Outlet } from "react-router-dom";
import { loginGQL, useLegacyMutation } from "@onmo/graphql/legacyGraphql";
import i18next from "i18next";
import { useLazyQuery, useMutation } from "@apollo/client";
import { PageRoutes } from "../constants/routes";
import { getLanguages } from "../models/settings";

export const AuthenticatedLayout = () => {
  const [getMe, { data: dataMe }] = useLazyQuery<{ me: Query["me"] }>(meGQL);
  const [login] = useLegacyMutation(loginGQL);
  const [updateUserMutation] = useMutation(updateUserGQL);

  useEffect(() => {
    const loginPromise = async () => {
      if (window.location.pathname !== PageRoutes.Home) {
        await login();
      }
      await getMe();
    };
    loginPromise();
  }, [login, getMe]);

  useEffect(() => {
    if (dataMe?.me?.language) {
      const { languages, default: defaultLang } = getLanguages();
      const lang = languages.includes(dataMe.me.language)
        ? dataMe.me.language
        : defaultLang || dataMe.me.language;
      i18next.changeLanguage(lang);
      localStorage.setItem("app_language", lang);
      if (lang !== dataMe.me.language) {
        updateUserMutation({
          variables: { input: { language: lang } },
        }).then(() => {
          getMe({ fetchPolicy: "network-only" });
        });
      }
    }
  }, [dataMe?.me?.language]);

  return <Outlet />;
};
